<template>
  <div class="language-selector" v-click-outside="hideLanguageList">
    <p 
      class="selected-language" 
      :class="{ 'active' : showLanguageList }" 
      @click="showLanguageList = !showLanguageList">
      <span v-if="selectedLanguage === 'en'" class="flag-icon flag-icon-gb"></span>
      <span v-else :class="'flag-icon flag-icon-' + selectedLanguage"></span>
      {{ $t('languages').find(lang => lang.code === selectedLanguage).name }}
    </p>

    <div class="language-list" v-if="showLanguageList">
      <ul>
        <li v-for="(language, languageIndex) in $t('languages')" :key="languageIndex">
          <a @click="switchLanguage(language)" v-if="language.code !== selectedLanguage" title="language.name">
            <span v-if="language.code === 'en'" class="flag-icon flag-icon-gb"></span>
            <span v-else :class="'flag-icon flag-icon-' + language.code"></span>
            {{ language.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {formsMixin} from "@/mixins/formsMixin";
import { mapGetters } from 'vuex'

export default {
  name: 'locale-changer',
  data() {
    return {
      selectedLanguage: this.$i18n.locale,
      showLanguageList: false,
      OpenIndicator: {
          render: createElement => createElement('i', {class: {'fa fa-chevron-down': true}}),
      }
    }
  },

  mixins: [formsMixin],

  computed: {
    ...mapGetters ([
    ])
  },

  methods: {
    hideLanguageList: function() {
      this.showLanguageList = false;
    },
    switchLanguage: function(language) {
      let self = this;

      self.selectedLanguage = language.code;
      self.showLanguageList = false;
      
      if (self.$i18n.locale !== language.code) {
        self.$i18n.locale = language.code;
        let params = self.$route.params;
        params.locale = language.code;
        self.$router.replace({name: self.$route.name, params: params, query: self.$route.query});
        //self.$moment.locale();
      }
    }
  },

  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
          el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
              vnode.context[binding.expression](event);
          }
          };
          document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
          document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    }
  }
}
</script>